import { render, staticRenderFns } from "./JSONTextArea.vue?vue&type=template&id=12dd0a02&"
import script from "./JSONTextArea.vue?vue&type=script&lang=js&"
export * from "./JSONTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports